import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import AIEduButton from '../../../components/Button/AIEduButton';
import styles from '../emergencyAlert.module.css';

const EmergencyAlertForm = ({
    isEditMode,
    isAlertTitleEditMode,
    isDescriptionEditMode,
    alertTitleText,
    descriptionText,
    selectedProvider,
    selectedAlertType,
    xmlBodyText,
    providers,
    alertTypes,
    onTitleEdit,
    onDescriptionEdit,
    onProviderChange,
    onAlertTypeChange,
    onXmlBodyChange,
    onTitleChange,
    onDescriptionChange,
    onSave,
    onDelete,
    f
}) => {

    return (
        <>
            {isEditMode ? (
                <div className='flex justify-content-between align-items-center'>
                    <div className='flex align-items-center'>
                        {!isAlertTitleEditMode ? (
                            <>
                                <span className={styles.emergency_alert_textStyle}>
                                    {alertTitleText}
                                </span>
                                <i
                                    className='pi pi-pencil ml-4 cursor-pointer'
                                    onClick={onTitleEdit}
                                />
                            </>
                        ) : (
                            <InputText
                                value={alertTitleText}
                                onChange={onTitleChange}
                                placeholder={f({ id: 'AI_EDU_ENTER_ALERT_TITLE' })}
                                className={styles.inputStyle}
                            />
                        )}
                    </div>
                    <div className='flex gap-2'>
                        <AIEduButton
                            label={f({ id: 'AI_EDU_DELETE' })}
                            className='btnDelete'
                            onClick={onDelete}
                        />
                        <AIEduButton
                            label={f({ id: 'AI_EDU_SAVE' })}
                            icon='pi pi-save'
                            className='btnPrimary'
                            onClick={onSave}
                        />
                    </div>
                </div>
            ) : (
                <div className='flex justify-content-between'>
                    <div
                        style={{ lineHeight: '2rem' }}
                        className={styles.emergency_alert_textStyle}
                    >
                        {f({ id: 'AI_EDU_ALERT_TITLE' })}
                    </div>
                    <InputText
                        value={alertTitleText}
                        onChange={onTitleChange}
                        placeholder={f({ id: 'AI_EDU_ENTER_ALERT_TITLE' })}
                        className={styles.inputStyle}
                    />
                </div>
            )}
            <div className={`${styles.horizontalRule} mt-4 mb-4`} />

            {isEditMode ? (
                <div className='flex justify-content-between align-items-center mt-4 mb-4'>
                    {!isDescriptionEditMode ? (
                        <div className='flex align-items-center'>
                            <span className={styles.emergency_alert_textStyle}>
                                {descriptionText}
                            </span>
                            <i
                                className='pi pi-pencil ml-4 cursor-pointer'
                                onClick={onDescriptionEdit}
                            />
                        </div>
                    ) : (
                        <InputText
                            value={descriptionText}
                            onChange={onDescriptionChange}
                            className={styles.inputStyle2}
                                placeholder={f({ id: 'AI_EDU_ENTER_ALERT_DESCRIPTION' })}
                        />
                    )}
                </div>
            ) : (
                <div className='mt-4 mb-4'>
                    <InputText
                        value={descriptionText}
                        onChange={onDescriptionChange}
                        className={styles.inputStyle2}
                        placeholder={f({ id: 'AI_EDU_ENTER_ALERT_DESCRIPTION' })}
                    />
                </div>
            )}
            <div className={`${styles.horizontalRule} mt-4 mb-4`} />

            <div className='flex justify-content-between mt-4 mb-4'>
                <div className={styles.emergency_alert_textStyle}>
                    {f({ id: 'AI_EDU_ALERT_PROVIDER' })}
                </div>
                <Dropdown
                    value={selectedProvider}
                    onChange={onProviderChange}
                    options={providers}
                    optionLabel='name'
                    placeholder={f({ id: 'AI_EDU_SELECT_ALERT_PROVIDER' })}
                    className={
                        styles.emergency_alert_dropdown + ' w-full md:w-14rem'
                    }
                />
            </div>

            <div className='flex justify-content-between mt-4 mb-4'>
                <div className={styles.emergency_alert_textStyle2}>
                    {f({ id: 'AI_EDU_TEMPLATE_TYPE' })}
                </div>
                <Dropdown
                    value={selectedAlertType}
                    onChange={onAlertTypeChange}
                    options={alertTypes}
                    optionLabel='name'
                    placeholder={f({ id: 'AI_EDU_SELECT_ALERT_TYPE' })}
                    className={
                        styles.emergency_alert_dropdown + ' w-full md:w-14rem'
                    }
                />
            </div>

            {selectedProvider?.code === 'raptor' && (
                <div className='flex justify-content-between mt-4 mb-4'>
                    <div className={styles.emergency_alert_textStyle2}>
                        {f({ id: 'AI_EDU_XML_BODY' })}
                    </div>
                    <InputTextarea
                        value={xmlBodyText}
                        onChange={onXmlBodyChange}
                        rows={5}
                        cols={30}
                        className={styles.emergency_inputTextArea}
                    />
                </div>
            )}
        </>
    );
};

export default EmergencyAlertForm;
